// frontend_react/src/services/addressApi.js

import api from "./api";

export const autocompleteAddress = (query, signal) =>
  api.get(`/maps/autocomplete?q=${encodeURIComponent(query)}`, {
    signal,
  });

export const getPlaceDetails = ({ lat, lng }) =>
  api.get(
    `/maps/place-details?lat=${encodeURIComponent(lat)}&lng=${encodeURIComponent(lng)}`
  );